<template>
  <div class="divBox">
    <el-card class="box-card">
      <el-form
        ref="formValidate"
        v-loading="fullscreenLoading"
        class="formValidate mt20"
        label-width="160px"
        v-model="formValidate"
        @submit.native.prevent
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="商品分类：" prop="cate_id">
              <el-cascader
                v-model="formValidate.cate_id"
                class="selWidth"
                :options="categoryList"
                :props="props"
                filterable
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="品牌：" prop="brand_id">
              <el-cascader
                v-model="formValidate.brand_id"
                class="selWidth"
                :options="brandList"
                :props="props"
                filterable
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="是否上架：" prop="is_show">
              <el-select
                v-model="formValidate.is_show"
                placeholder="请选择"
                class="filter-item selWidth"
                clearable
              >
                <el-option label="上架" value="1"/>
                <el-option label="下架" value="0"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="排序：" prop="title">
              <el-input-number :min=0 v-model="formValidate.sort"  />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="外部商品链接：">
              <el-table
                :data="data"
                border
                size="small"
                style="width: 100%"
              >
                <el-table-column align="center" prop="store_link" label="外部商品链接" min-width="200">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.store_link" class="priceBox"/>
                  </template>
                </el-table-column>
                <el-table-column align="center" label="操作" min-width="120">
                  <template slot-scope="scope">
                    <el-button type="text" class="submission" @click="delSpecs(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="onAdd">添加参数</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item style="margin-top:30px;">
          <el-button :loading="loading" type="primary" class="submission" size="small" @click="handleSubmit()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
import {
  categoryTopicListApi, communityDetailApi, saveCommunityDataApi
} from '@/api/community'
import { roterPre } from '@/settings'
import {brandSearchListApi, categoryListApi, saveOutreachDataApi} from "@/api/product";
const defaultObj = {
  cate_id: '',
  brand_id: '',
  store_link: '',
}
export default {
  name: 'AssConfig',
  data() {
    return {
      roterPre: roterPre,
      fullscreenLoading: false,
      formValidate: Object.assign({}, defaultObj),
      loading: false,
      grid2: {
        xl: 10,
        lg: 12,
        md: 12,
        sm: 24,
        xs: 24
      },
      grid: {
        xl: 8,
        lg: 8,
        md: 12,
        sm: 24,
        xs: 24
      },
      storeTypeMap: {},
      progress: 0,
      categoryList: [],
      data: [],
      props: { emitPath: false },
      brandList:[],
    }
  },
  mounted() {
    this.onAdd();
    this.getCategoryList()
    this.getBrandList()
  },
  methods: {
    onAdd() {
      let obj = { store_link: "" };
      this.data.push(obj);
    },
    // 删除
    delSpecs(idx) {
      this.data.splice(idx, 1);
    },
    // 平台分类
    getCategoryList() {
      categoryListApi({'min_level': 1})
        .then(res => {
          this.categoryList = res.data
        })
        .catch(res => {
          this.$message.error(res.message)
        })
    },
    getBrandList() {
      brandSearchListApi()
        .then(res => {
          this.brandList = res.data
        })
        .catch(res => {
          this.$message.error(res.message)
        })
    },
    // 提交
    handleSubmit() {
      if (!this.formValidate.cate_id) {
          this.$message.error('请选择分类')
          return false
      }
      if (!this.formValidate.brand_id) {
        this.$message.error('请选择品牌')
        return false
      }
      if (!this.formValidate.is_show) {
        this.$message.error('请选择状态')
        return false
      }
      if (!this.data) {
        this.$message.error('请填写外部链接')
        return false
      }
      this.formValidate.store_link = this.data;
      saveOutreachDataApi(this.formValidate)
        .then(res => {
          this.fullscreenLoading = false
          this.$message.success(res.message)
          this.$router.push({ path: this.roterPre + '/product/outreach' })
          this.loading = false
        })
        .catch(res => {
          this.fullscreenLoading = false
          this.loading = false
          this.$message.error(res.message)
        })
    }
  }
}
</script>
<style scoped lang="scss">
.label_tip{
  display: inline-block;
  margin-left: 20px;
  color: #C0C4CC;
}
.selWidth {
  width: 100%;
}
.selWidthd {
  width: 300px;
}
.dialog-scustom,.addDia{
  min-width: 400px;
  height: 900px;
  .el-dialog{
    width: 400px;
  }
  h3{
    color: #333;
    font-size: 16px;
    text-align: center;
    font-weight: bold;
    margin: 0;
  }
}
.pictrue {
  width: 60px;
  height: 60px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  margin-right: 10px;
  position: relative;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
}
.agreement{
  width: 350px;
  margin: 0 auto;
  box-shadow: 1px 5px 5px 2px rgba(0,0,0,.2);
  padding: 26px;
  border-radius: 15px;
  .content{
    height: 600px;
    overflow-y:scroll;
    /deep/ p{
      font-size: 13px;
      line-height: 22px;
    }
  }
  /deep/ img{
    max-width: 100%;
  }
  p{
    text-align: justify;
  }
}
/*css主要部分的样式*/
/*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 10px; /*对垂直流动条有效*/
  height: 10px; /*对水平流动条有效*/
}
/*定义滚动条的轨道颜色、内阴影及圆角*/
::-webkit-scrollbar-track{
  /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);*/
  background-color: transparent;
  border-radius: 3px;
}
.iview-video-style {
  width: 40%;
  height: 180px;
  border-radius: 10px;
  background-color: #707070;
  margin-top: 10px;
  position: relative;
  overflow: hidden;
}
.iconv {
  color: #fff;
  line-height: 180px;
  display: inherit;
  font-size: 26px;
  position: absolute;
  top: -74px;
  left: 50%;
  margin-left: -25px;
}
.iview-video-style .mark {
  position: absolute;
  width: 100%;
  height: 30px;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  text-align: center;
}
.uploadVideo {
  margin-left: 10px;
}
.perW50 {
  width: 50%;
}
.submission {
  margin-left: 10px;
}
.btndel {
  position: absolute;
  z-index: 1;
  width: 20px !important;
  height: 20px !important;
  left: 46px;
  top: -4px;
}

</style>
